<template>
  <div class="box-information-content">
    <a-card :bordered="false" size="small">
      <div slot="title" class="title-box">
        <label class="plate-title"><strong>Note</strong></label>
      </div>
      <a-row :gutter="24">
        <a-col :sm="24" :md="12">
          <a-card title="External Note" size="small">
            <a slot="extra" @click="showModalExternalAdd">Add Note</a>
            <a-timeline>
              <a-timeline-item color="green">
                <div class="note-exter">
                  <div class="flex-1">
                    <span>From:</span>
                    <span class="name">chennian</span>
                    <span class="data">07/15/2021 4:06PM</span>
                    <p>test-test-test-test-test</p>
                  </div>
                  <a-popconfirm
                    title="Are you sure?"
                    ok-text="Yes" 
                    cancel-text="No"

                  >
                    <a class="delete" style="margin-right: 10px;"><a-icon type="delete" /></a>
                  </a-popconfirm>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-card>
        </a-col>
        <!-- 右边 -->
        <a-col :sm="24" :md="12">
          <a-card title="Internal Note" size="small">
            <a slot="extra" @click="showModalInternalAdd">Add Note</a>
            <a-timeline>
              <a-timeline-item color="green">
                <div class="note-exter">
                  <div class="flex-1">
                    <span>From:</span>
                    <span class="name">chennian</span>
                    <span class="data">07/15/2021 4:06PM</span>
                    <p>test-test-test-test-test</p>
                  </div>
                  <a-popconfirm
                    title="Are you sure?"
                    ok-text="Yes" 
                    cancel-text="No"

                  >
                    <a class="delete" style="margin-right: 10px;"><a-icon type="delete" /></a>
                  </a-popconfirm>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-card>
        </a-col>
      </a-row>
      <!-- 弹框一 -->
       <a-modal
          title="Add Internal Note"
          v-model="visible"
          @ok="handleExternalAdd"
        >
          <div>
            <a-form layout='horizontal'>
              <a-form-item
                label='Description'
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
              >

                <a-textarea
                  placeholder="Description" 
                  :rows="4"
                  v-decorator="[
                    'description',
                    {
                    rules: [{ required: true, message: '' }],
                    }
                  ]"
                />
              </a-form-item>
              <a-form-item v-show="false">
                <a-input
                
                />
              </a-form-item>
            </a-form>
          </div>
          <div slot="footer">
            <a-row type="flex" justify="end">
              <a-col :xs="9" :md="5">
                <a-popconfirm
                    title="Are you sure?"
                    
                    ok-text="Yes" 
                    cancel-text="No"
                    :loading="loading"
                  >
                    <a-button type="primary">
                      Confirm
                    </a-button>
                  </a-popconfirm>
              </a-col>
            </a-row>
          </div>
        </a-modal>
        <!-- 弹框二 -->
        <a-modal
          title="Add Internal Note"
          v-model="visible"
           @ok="handleInternalAdd"
        >
          <div>
            <a-form layout='horizontal'>
              <a-form-item
                label='Description'
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
              >

                <a-textarea
                  placeholder="Description" 
                  :rows="4"
                  v-decorator="[
                    'description',
                    {
                    rules: [{ required: true, message: '' }],
                    }
                  ]"
                />
              </a-form-item>
              <a-form-item v-show="false">
                <a-input
                
                />
              </a-form-item>
            </a-form>
          </div>
          <div slot="footer">
            <a-row type="flex" justify="end">
              <a-col :xs="9" :md="5">
                <a-popconfirm
                    title="Are you sure?"
                    
                    ok-text="Yes" 
                    cancel-text="No"
                    :loading="loading"
                  >
                    <a-button type="primary">
                      Confirm
                    </a-button>
                  </a-popconfirm>
              </a-col>
            </a-row>
          </div>
        </a-modal>
    </a-card>
  </div>
</template>

<script>

export default {
  name: 'BookNoteMain',
  components: {
  },
  props: {
  },
  data () {
    return {
      visible: false,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    }
  },
  mounted () {
  },
  methods: {
    // External弹框
    showModalExternalAdd() {
      this.visible = true
    },
    handleExternalAdd(e) {
      console.log(e)
      this.visible = false
    },
    // Internal弹框
    showModalInternalAdd () {
      this.visible = true
    },
    handleInternalAdd(e) {
      console.log(e)
      this.visible = false
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .note-exter {
  display: flex;
  align-items: center;  
  font-size: 16px;
  color: #333;
  margin: 6px 0;
}
/deep/ .note-exter p{
  color: rgba(0,0,0,.65);
}
/deep/ .note-exter span{
  margin-right: 20px;
}
/deep/ .data{
  color: #999;
  position: relative;
  top: 1px;
}
/deep/ .ant-timeline-item-head {
  margin-top: 2px;
}
/deep/ .ant-timeline-item {
  padding-bottom: 0;
}
</style>